import styles from "./Section.module.less";
import clsx from "clsx";

export const SectionTitle = ({ children }) => {
  return <h2 className={clsx(styles.SectionTitle)}>{children}</h2>;
};
